import styles from './ListGrid.module.css';

function ListGrid(props) {
  return (
    <div className={styles.grid}>
      <div className={styles.header}>{props.header}</div>
      <div className={styles.body}>{props.body}</div>
    </div>
  );
}

export default ListGrid;